import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { getOpenedTaskDescription } from '../../../../../redux/tasks/taskEntities/selectors';
import EditableTaskDescription from '../EditableTaskDescription';

const TaskDetailsDescription = ({ isGuest, isModal, taskDescription, taskId }) => {
  return (
    <>
      <div className="flex align-center mt-5 mb-2">
        <div className="font-18 font-bold">
          <FormattedMessage
            id="DESCRIPTION"
            defaultMessage="Description"
          />
        </div>
      </div>
      <div className="w-full">
        <EditableTaskDescription
          description={taskDescription}
          isModal={isModal}
          taskId={taskId}
          isGuest={isGuest}
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  isGuest: state?.userReducer?.role === 'guest',
  taskId: getOpenedTaskId(state),
  taskDescription: getOpenedTaskDescription(state),
});

export default connect(mapStateToProps)(TaskDetailsDescription);
